import { Button, Grid } from "@material-ui/core";
import { useCallback, useEffect, useState } from "react";
import useStyles from "../../style";
import Cropper from "react-easy-crop";
import "./style.css";
import getCroppedImg from "./cropedImage";
import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import VideoPayer from "./videoPayer";
import { useDispatch } from "react-redux";
import { showError } from "../../../../actions";

export default function UploadFile({
  croppedImage,
  setCroppedImage,
  video,
  setVideo,
  document,
  setDocument,
  files,
  removeFiles,
  setRemoveFiles,
  disableDocuemnt,
}) {
  const classes = useStyles();
  const [img, setImg] = useState("");
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImageUrl, setCroppedImageUrl] = useState([]);
  const dispatch = useDispatch();

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage2 = await getCroppedImg(img, croppedAreaPixels);
      setCroppedImage([...croppedImage, croppedImage2.file]);
      setCroppedImageUrl([...croppedImageUrl, croppedImage2.url]);
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels]);

  useEffect(() => {
    if (files[0])
      files?.map((file) => {
        if (
          file.file.includes(".webm") ||
          file.file.includes(".ogg") ||
          file.file.includes(".mp4")
        ) {
          setVideo((prev) => [
            ...prev,
            `https://backend.ayandehsazan.ir${file.file}`,
          ]);
        } else if (
          file.file.includes(".jpg") ||
          file.file.includes(".png") ||
          file.file.includes(".jpeg") ||
          file.file.includes(".gif")
        ) {
          setCroppedImageUrl((prev) => [
            ...prev,
            `https://backend.ayandehsazan.ir${file.file}`,
          ]);
        } else {
          setDocument([...document, file]);
        }
      });
  }, [files]);
  const handleChooseFileModal = () => {
    window.document.querySelector("#imageAndVideoUpload").click();
  };
  const handleChooseDocumentModal = () => {
    window.document.querySelector("#documentUpload").click();
  };
  const handleChooseFile = (e) => {
    try {
      if (
        e.target.files[0].type.includes("webm") ||
        e.target.files[0].type.includes("ogg") ||
        e.target.files[0].type.includes("mp4")
      ) {
        setVideo([...video, e.target.files[0]]);
      } else if (e.target.files[0].type.includes("image")) {
        var FR = new FileReader();
        FR.addEventListener("load", function (event) {
          setImg(event.target.result);
        });
        FR.readAsDataURL(e.target.files[0]);
      } else if (e.target.files[0].type.includes("video")) {
        dispatch(showError({ message: "فرمت باید mp4 یا ogg یا webm باشد" }));
      }
    } catch (e) {
      // document.getElementById("profileImage").src = profileImage;
    }
  };
  const handleChooseDocument = (e) => {
    try {
      if (
        e.target.files[0].type.includes("video") ||
        e.target.files[0].type.includes("image")
      ) {
        dispatch(
          showError({ message: "عکس و ویدیو را در قسمت بالا آپلود کنید" })
        );
      } else if (e.target.files[0]) {
        setDocument([...document, e.target.files[0]]);
      }
    } catch (e) {
      dispatch(showError({ message: "خطایی رخ داده است" }));
    }
  };
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      style={{ marginTop: 40, position: "relative" }}
    >
      <Grid
        container
        direction="column"
        alignItems="center"
        style={{ width: "fit-content", position: "relative" }}
      >
        <Grid item style={{ fontWeight: "700", marginBottom: 10 }}>
          آپلود تصویر و ویدیو
        </Grid>
        <Grid
          item
          className={`${classes.selectFile} add_activity_upload_video_image`}
          onClick={handleChooseFileModal}
        >
          انتخاب فایل
        </Grid>
        <input
          type="file"
          id="imageAndVideoUpload"
          className={classes.fileInput}
          onChange={handleChooseFile}
        />
      </Grid>
      <Grid container style={{ padding: "0 30px" }}>
        <Cropper
          image={img}
          crop={crop}
          zoom={zoom}
          aspect={6.954 / 4}
          onCropChange={setCrop}
          onCropComplete={onCropComplete}
          onZoomChange={setZoom}
        />
      </Grid>
      <Grid container justify="center" className={classes.saveImageContainer}>
        <Grid
          container
          justify="space-between"
          alignItems="center"
          className={classes.saveImageInsideContainer}
        >
          <DeleteOutlineRoundedIcon
            style={{ cursor: "pointer" }}
            onClick={() => {
              setImg("");
            }}
          />
          <Button
            onClick={showCroppedImage}
            variant="contained"
            className={classes.saveImage}
          >
            ذخیره عکس
          </Button>
        </Grid>
      </Grid>
      <Grid container style={{ padding: "0 30px" }}>
        <Grid container className={classes.divider} />
      </Grid>
      <Grid
        container
        direction="row-reverse"
        className={classes.imageSectionContainer}
      >
        {croppedImageUrl &&
          croppedImageUrl.map((item, index) => {
            return (
              <Grid
                item
                md={4}
                container
                justify="center"
                style={{
                  marginTop:
                    croppedImageUrl?.length + video?.length > 3 ? 30 : 0,
                  position: "relative",
                }}
                key={index}
              >
                <Grid item style={{ position: "relative" }}>
                  <img
                    key={index}
                    src={item}
                    alt="croppedImage"
                    style={{ width: 200 }}
                  />
                  <CloseRoundedIcon
                    style={{
                      position: "absolute",
                      top: 1,
                      right: 5,
                      cursor: "pointer",
                      color: "red",
                    }}
                    onClick={() => {
                      setCroppedImageUrl(
                        croppedImageUrl.filter((el) => el !== item)
                      );
                      setRemoveFiles([...removeFiles, item]);
                    }}
                  />
                </Grid>
              </Grid>
            );
          })}
        {video &&
          video.map((item, index) => {
            return (
              <Grid
                item
                md={4}
                container
                justify="center"
                style={{
                  marginTop:
                    croppedImageUrl?.length + video?.length > 3 ? 30 : 0,
                  position: "relative",
                }}
                key={index}
              >
                <Grid item style={{ position: "relative" }}>
                  <VideoPayer item={item} controls style={{ width: 200 }} />
                  <CloseRoundedIcon
                    style={{
                      position: "absolute",
                      top: 1,
                      right: 5,
                      cursor: "pointer",
                      color: "red",
                    }}
                    onClick={() => {
                      setVideo(video.filter((el) => el !== item));
                      setRemoveFiles([...removeFiles, item]);
                    }}
                  />
                </Grid>
              </Grid>
            );
          })}
      </Grid>
      {typeof disableDocuemnt === "undefined" && disableDocuemnt && (
        <>
          <Grid
            container
            justify="center"
            className={classes.documentContainer}
          >
            <Grid
              container
              direction="column"
              alignItems="center"
              style={{ width: "fit-content", position: "relative" }}
            >
              <Grid item style={{ fontWeight: "700", marginBottom: 10 }}>
                آپلود اسناد
              </Grid>
              <Grid
                item
                className={`${classes.selectFile} add_activity_upload_doc`}
                onClick={handleChooseDocumentModal}
              >
                انتخاب فایل
              </Grid>
              <input
                type="file"
                id="documentUpload"
                className={classes.fileInput}
                onChange={handleChooseDocument}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction="column"
            className={classes.documentBoxContainer}
          >
            {document?.map((doc, index) => {
              return (
                <Grid
                  container
                  justify="space-between"
                  alignItems="center"
                  key={doc.name + index}
                  className={classes.documentItemContainer}
                >
                  <Grid item className={classes.removeContainer}>
                    <DeleteOutlineRoundedIcon
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        if (doc.file)
                          setRemoveFiles([
                            ...removeFiles,
                            `https://backend.ayandehsazan.ir${doc.file}`,
                          ]);
                        setDocument(document.filter((el) => el !== doc));
                      }}
                      className={classes.removeDocIcon}
                    />
                  </Grid>
                  <Grid item className={classes.documentSize}>
                    {Math.ceil(doc.size / 1000)}KB
                  </Grid>
                  <Grid item className={classes.documentTitle}>
                    {doc.name}
                  </Grid>
                </Grid>
              );
            })}
          </Grid>
        </>
      )}
    </Grid>
  );
}
